import { Component, OnInit, Input } from '@angular/core';
import { Project } from '../project'
import { ProjectService } from '../project.service'
import { Observable }  from 'rxjs/Observable';

@Component({
  selector: 'app-project-box',
  templateUrl: './project-box.component.html',
  styleUrls: ['./project-box.component.css']
})
export class ProjectBoxComponent implements OnInit {
  @Input() project: Project
  @Input() isEdit = false

  private projectTitle = ''
  private projectShortcut = ''
  private submitProjectClicked = false
  private isDelete = false

  constructor(
    private projects: ProjectService
  ) { }

  ngOnInit() {
    if (!this.project)
      this.project = this.projects.newProject()
  }

  ngOnDestroy() {
    if (this.project.isNew)
      this.projects.projectMap.delete(this.project.id)
  }

  init() {
    this.projectTitle = this.project.title
    this.projectShortcut = this.project.shortcut
  }

  switchEdit() {
    if (this.isEdit)
      this.ngOnDestroy()

    this.isEdit = !this.isEdit
    if (this.isEdit)
      this.init()
  }

  switchDelete() {
    this.isDelete = !this.isDelete
  }

  confirmDelete() {
    let obs: Observable<any> = this.projects.delete(this.project)
    obs.subscribe((x) => null)
  }

  get hasProjectTitleError() {
    if (!this.submitProjectClicked)
      return false
    return !this.projectTitle.length
  }

  get hasProjectShortcutError() {
    if (!this.submitProjectClicked)
      return false
    return !this.projectShortcut.length || !/^[a-z][a-z0-9_-]/.test(this.projectShortcut.trim())
  }

  save() {
    this.submitProjectClicked = true
    if (this.hasProjectTitleError || this.hasProjectShortcutError)
      return
    this.project.title = this.projectTitle
    this.project.shortcut = this.projectShortcut
    let obs: Observable<any> = this.projects.save(this.project)
    obs.subscribe((x) => this.switchEdit())
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/project-box/project-box.component.ts